import { DocumentTextIcon, Bars3CenterLeftIcon } from "@heroicons/react/24/outline";

const StaticContentRoutes = [
    {
        path: "static-content",
        fullPath: "content-management/static-content",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Static Content",
        icon: DocumentTextIcon,
        children: [
            {
                path: "privacy-policy",
                fullPath: "content-management/static-content/privacy-policy",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Privacy Policy",
                displayPath: "Static Content > Privacy Policy",
                icon: Bars3CenterLeftIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/PrivacyPolicy/index"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["privacy-policy-list"],
                    },
                    {
                        path: "create/:slug",
                        async lazy() {
                            const component = await import(
                                "../../pages/PrivacyPolicy/Upsert"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["privacy-policy-list"],
                    },
                    {
                        path: "edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/PrivacyPolicy/Upsert"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["privacy-policy-edit"],
                    },
                ],
            },
            {
                path: "about-us",
                fullPath: "content-management/static-content/about-us",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "About Us",
                displayPath: "About Us > About Us",
                icon: Bars3CenterLeftIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/PrivacyPolicy/index"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["privacy-policy-list"],
                    },
                    {
                        path: "create/:slug",
                        async lazy() {
                            const component = await import(
                                "../../pages/PrivacyPolicy/Upsert"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["privacy-policy-list"],
                    },
                    {
                        path: "edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/PrivacyPolicy/Upsert"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["privacy-policy-edit"],
                    },
                ],
            },
            {
                path: "cancellation-policy",
                fullPath: "content-management/static-content/cancellation-policy",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Cancellation Policy",
                displayPath: "Cancellation Policy > Cancellation Policy",
                icon: Bars3CenterLeftIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/PrivacyPolicy/index"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["privacy-policy-list"],
                    },
                    {
                        path: "create/:sllug",
                        async lazy() {
                            const component = await import(
                                "../../pages/PrivacyPolicy/Upsert"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["privacy-policy-list"],
                    },
                    {
                        path: "edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/PrivacyPolicy/Upsert"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["privacy-policy-edit"],
                    },
                ],
            },
            {
                path: "faq-categories",
                fullPath: "content-management/static-content/faq-categories",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "FAQ",
                displayPath: "Static Content > FAQ Categories",
                icon: Bars3CenterLeftIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/FaqCategories/index"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["faq-categories-list"],
                    },
                    {
                        path: "create",
                        async lazy() {
                            const component = await import(
                                "../../pages/FaqCategories/Edit"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["faq-categories-create"],
                    },
                    {
                        path: "edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/FaqCategories/Edit"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["faq-categories-edit"],
                    },
                    {
                        path: "details/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/Faq/Categories"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["faq-categories-view"],
                    },
                    {
                        path: "details/:categoryId/create",
                        async lazy() {
                            const component = await import(
                                "../../pages/Faq/Edit"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["faq-create"],
                    },
                    {
                        path: "details/:categoryId/edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/Faq/Edit"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["faq-edit"],
                    },
                ],
            },
            {
                path: "terms-and-condition-categories",
                fullPath: "content-management/static-content/terms-and-condition-categories",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Terms and Conditions",
                displayPath: "Static Content > Terms and Conditions",
                icon: Bars3CenterLeftIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/TermsAndConditionCategories/index"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        permissions: ["terms-and-condition-categories-list"],
                    },
                    {
                        path: "create",
                        async lazy() {
                            const component = await import(
                                "../../pages/TermsAndConditionCategories/Edit"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["terms-and-condition-categories-create"],
                    },
                    {
                        path: "edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/TermsAndConditionCategories/Edit"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["terms-and-condition-categories-create"],
                    },
                    {
                        path: "details/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/TermAndConditionContent/Categories"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["terms-and-condition-content-list"],
                    },
                    {
                        path: "details/:categoryId/create",
                        async lazy() {
                            const component = await import(
                                "../../pages/TermAndConditionContent/Edit"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["terms-and-condition-content-create"],
                    },
                    {
                        path: "details/:categoryId/edit/:id",
                        async lazy() {
                            const component = await import(
                                "../../pages/TermAndConditionContent/Edit"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                        exact: true,
                        permissions: ["terms-and-condition-content-edit"],
                    },
                ],
            },
        ],
    },
];

export default StaticContentRoutes;
